import type { ClientGPSLocation } from '@DigitaleDoerfer/digitale-doerfer-api';
import { getCurrentPositionAsync } from 'expo-location';

export const getCurrentLocation = async (): Promise<
  ClientGPSLocation | undefined
> => {
  try {
    const { coords } = await getCurrentPositionAsync({});
    return { latitude: coords.latitude, longitude: coords.longitude };
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.warn(
        'Could not get current location, consider using the location guards.',
        error.message
      );
    }
  }
};
